export interface NmiEnvironmentConfig {
  test: {
    apiKey: string | undefined;
    scriptUrl: string;
    scriptId: string;
  };
  production: {
    apiKey: string | undefined;
    scriptUrl: string;
    scriptId: string;
  };
}

export const NMI_CONFIG: NmiEnvironmentConfig = {
  test: {
    apiKey: process.env.NEXT_PUBLIC_NMI_API_KEY_SANDBOX,
    scriptUrl: "https://secure.safewebservices.com/token/Collect.js",
    scriptId: "nmiApiKey-test",
  },
  production: {
    apiKey: process.env.NEXT_PUBLIC_NMI_API_KEY,
    scriptUrl: "https://secure.safewebservices.com/token/Collect.js",
    scriptId: "nmiApiKey-prod",
  },
};

export const getNmiConfig = (environment: "test" | "production") => {
  return NMI_CONFIG[environment];
};

export const validateNmiConfig = (): boolean => {
  const hasTestKey = !!NMI_CONFIG.test.apiKey;
  const hasProdKey = !!NMI_CONFIG.production.apiKey;

  return hasTestKey && hasProdKey;
};
